import React from "react";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import { PiMouseLeftClickLight } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import cvFR from "./../assets/cv.pdf";
import cvEN from "./../assets/cv-en.pdf";


const Footer = () => {
   const CV_BY_LANG = {
     fr: cvFR,
     en: cvEN,
   };
   const { t, i18n } = useTranslation();
   const lang = i18n.language.split("-")[0];
   const cvFile = CV_BY_LANG[lang] || cvFR;

    return (
        <div className="footer">
            <div className="footer-container">
                <div className="container ">
                    <div className="row pt-5 align-items-end">
                        <div className="col">
                            <img src={require("./../assets/portraitRonde.jpg")} alt="portrait" className="photoRonde " />
                            <h1 className="name text-md-start text-center">Sophie Garant-Ducas</h1>
                            <h2 className="titre text-md-start text-center pb-3 pb-md-0">{t('job.title')}</h2>

                        </div>
                        <div className="col">
                            <h5 className="text-md-end text-center"><a href="tel:5819283611"><MdOutlinePhone /> (581) 928-3611</a></h5>
                           <h5 className="text-md-end text-center"> <a href="mailto:sgarantducas@hotmail.ca"><MdOutlineEmail /> sgarantducas@hotmail.ca</a></h5>
                           <h5 className="text-md-end text-center"> <a href="https://www.linkedin.com/in/sgarantducas/" className="decoration-none"><FaLinkedinIn /> sgarantducas</a></h5>
                           <h5 className="text-md-end text-center lienCV"> <a href={cvFile} target="blank" className=""><PiMouseLeftClickLight />{t('btn.cv')} </a></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
